
import { supabase } from '@/integrations/supabase/client';
import { Bike } from '@/services/types';

export interface BikeDataResult {
  bikes: Bike[];
  totalCount: number;
  dataSource: 'supabase' | 'mock';
  connectionError: string | null;
}

/**
 * Получает все данные о велосипедах без пагинации
 */
export const fetchAllBikes = async (): Promise<BikeDataResult> => {
  try {
    console.log('🚲 НАЧИНАЕМ ЗАГРУЗКУ ВЕЛОСИПЕДОВ');
    console.log('Получение всех данных велосипедов...');
    
    let query = supabase
      .from('bikes')
      .select(`
        *,
        rentals!left (
          id,
          human_number,
          status,
          courier_id,
          couriers!left (
            id,
            name,
            phone
          )
        )
      `, { count: 'exact' });

    const { data, error, count } = await query;

    if (error) {
      console.error('Ошибка при получении велосипедов:', error);
      throw error;
    }

    const totalCount = count || 0;
    console.log(`Получено ${data?.length || 0} велосипедов из ${totalCount}`);

    // Обрабатываем данные в том же формате что и BikeDataService
    const processedBikes: Bike[] = (data || []).map((bike: any) => {
      // Получаем активную аренду (включая assigned)
      const activeRental = bike.rentals && bike.rentals.length > 0 
        ? bike.rentals.find((r: any) => r.status === 'active' || r.status === 'pending' || r.status === 'assigned') 
        : null;
      
      const courier = activeRental?.couriers;
      

      return {
        id: bike.id,
        serialNumber: bike.serial_number,
        model: bike.model,
        status: bike.status,
        mileage: bike.mileage || 0,
        lastMaintenance: bike.last_service_date || new Date().toISOString(),
        gps_tag: bike.gps_tag,
        amo_number: bike.amo_number,
        movement_blocked: bike.movement_blocked || false,
        speed_limit: bike.speed_limit,
        max_allowed_speed: bike.max_allowed_speed || 25,
        last_movement_update: bike.last_movement_update,
        courierName: courier?.name || null,
        courier_phone: courier?.phone || null,
        rental_id: activeRental?.id || null,
        rental_human_number: activeRental?.human_number || null
      };
    });

    
    return {
      bikes: processedBikes,
      totalCount,
      dataSource: 'supabase',
      connectionError: null
    };

  } catch (error: any) {
    console.error('Ошибка при получении данных о велосипедах:', error);
    
    return {
      bikes: [],
      totalCount: 0,
      dataSource: 'mock' as const,
      connectionError: error.message
    };
  }
};

// Оставляем старые функции для обратной совместимости
export const fetchBikesWithPagination = fetchAllBikes;
export const fetchBikesStats = fetchAllBikes;
